/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export const supportImageGrid = {
  default: "grid-col-1-15",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-2-10 grid-row-5-6"
};

export const supportImageCaptionGrid = {
  default: "grid-col-2-14",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-2-10 grid-row-6-7"
};

export const supportSectionGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-1-2"
};

export const supportHealineGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-2-3"
};

export const supportSubheadlineGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-3-4"
};

export const supportAmazonPollyGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-4-5"
};

export const supportHeaderGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-3-10"
};

export const supportCardGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-3-13",
  "headline-priority": "grid-col-3-10"
};

export const supportSidebarGrid = {
  default: "grid-col-10-14 grid-row-4-11",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-10-14 grid-row-1-13"
};
